module.exports = __webpack_public_path__ + "officialStatic/img/logo5.efe752c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/logo5.png
// module id = JWT8
// module chunks = 0